<template>
	<div>
		<TableList :where='where' :scroll="{x:1500}" :form_data_seo.sync="form_data_seo" :columns="columns"
			:get_table_list="this.get_table_list"
			:is_created_get_list='false'
			:slot_table_list="['operation','status','users','use_num','factory_name','rule_tag','rule_item']"
			:submit_preprocessing="submit_preprocessing" ref="list">
			<template slot="left_btn">
				<a-button class="float_left" @click="editAdd" type="primary">新增</a-button>
			</template>
			<template slot="users" slot-scope="data">
				<p>{{data.record.username}}</p>
				<p>部门:{{data.record.department_name}}</p>
			</template>
			<template slot="factory_name" slot-scope="data">
				<p @click='see_rule(data.record)'><a>{{data.record.factory_name}}</a></p>
				<a @click='see_rule(data.record)'>ID:{{data.record.factory_id}}</a>
			</template>
			<template slot="rule_tag" slot-scope="data">
				<template v-if=" data.record.rule_tag.length>0"></template>
				<p :class='it.type!=1?"nowTime":"wTime"' v-for='(it,key) in data.record.rule_tag'>
					{{it.text}}
				</p>
			</template>
			<template slot="rule_item" slot-scope="data">
				<p>
					开始:{{data.record.start_date}}
				</p>
				<p>
					结束:{{data.record.end_date?data.record.end_date:data.record.status==2?'至今':'长期'}}
				</p>

			</template>
			<template slot="status" slot-scope="data">
				<p :class='data.record.status==1?"status2":data.record.status==3?"status3":"status1"'>
					{{data.record.status==1?'待开始':data.record.status==2?'进行中':'已结束'}}
				</p>
			</template>
			<template slot="operation" slot-scope="data">
				<p>
					<span>
						<a v-if="data.record.status==1" @click='editAdd(data.record)'>
							编辑
						</a>

						<a v-if="data.record.status==2" @click='editFun(data.record)'>
							编辑
						</a>

						<a-divider v-if="data.record.status==2" type="vertical" />
						<a style="color: #FF9316" v-if="data.record.status==2" @click='endTime(data.record)'>
							结束驻场
						</a>
						<a-divider v-if="data.record.status!=1" type="vertical" />
						<span v-if="data.record.status!=1" @click='goReport(data.record)'>
							打卡记录
						</span>
						<a-divider v-if='data.record.status==1' type="vertical" />
						<a v-if='data.record.status==1' @click="del_visibleFun(data.record)" style="color: #ff4d4f">
							删除
						</a>


					</span>
				</p>
			</template>
		</TableList>

		<a-modal title="删除提醒" width='40%' :maskClosable='true' :visible="del_visible" @cancel='del_visible=false'
			@ok='del'>

			<a-descriptions :column='2'>
				<a-descriptions-item label="驻场ID">
					{{delnInfo.factory_id}}
				</a-descriptions-item>
				<a-descriptions-item label="驻场人员">
					{{delnInfo.username}}(ID:{{delnInfo.id}})
				</a-descriptions-item>
				<a-descriptions-item label="预计开始时间">
					{{delnInfo.start_date}}
				</a-descriptions-item>
				<a-descriptions-item label="预计结束时间">
					{{delnInfo.end_date?delnInfo.end_date:'长期'}}
				</a-descriptions-item>
			</a-descriptions>
			<div class="tips">
				<p><a-icon theme="filled" :style="{ fontSize: '16px', color: 'orange',marginRight:'12px' }"
						type="warning" />
					是否确认删除当前人员外派驻场，<span class='org'>此操作不可逆，请谨慎操作</span></p>
			</div>

		</a-modal>




		<a-modal title="编辑驻场日期" width='40%' :maskClosable='true' :visible="edit_visible" @cancel='edit_visible=false'
			@ok='edit_visible_fun'>
			<div class="tips">
				<p><a-icon theme="filled" :style="{ fontSize: '16px', color: 'orange',marginRight:'12px' }"
						type="warning" />

					温馨提示： <span class='blue'>进行中 ，</span> 状态的驻场人员<span class='org'>仅支持</span> 修改结束日期</p>
			</div>

			<a-descriptions :column='1'>
				<a-descriptions-item label="驻场ID">
					{{chooseinfo.factory_id}}
				</a-descriptions-item>
				<a-descriptions-item label="驻场人员">
					{{chooseinfo.username}}(ID:{{chooseinfo.id}})
				</a-descriptions-item>
				<a-descriptions-item label="驻场开始时间">
					{{chooseinfo.start_date}}
				</a-descriptions-item>

				<a-descriptions-item label="驻场结束时间">
					<div class="date-picker-wrapper">
						<!-- 使用 a-badge 添加角标 -->
						<a-date-picker v-model:value="chooseinfo.end_date" valueFormat="YYYY-MM-DD" placeholder="请选择日期"
							style="width: 220px;" :disabled-date="disabledDate" />
						<!-- 添加样式类以匹配灰色提示 -->
						<p class="tip-text">留空表示长期驻场，后续可随时修改</p>
					</div>
				</a-descriptions-item>

			</a-descriptions>

		</a-modal>


		<a-modal title="结束驻场" width='40%' :maskClosable='true' :visible="end_visible" @cancel='end_visible=false'
			@ok='setEndTime'>
			<div class="tips">
				<p><a-icon theme="filled" :style="{ fontSize: '16px', color: 'orange',marginRight:'12px' }"
						type="warning" />温馨提示：当前人员 <span class='org'>未到驻场结束日期</span> 或为<span class='org'>长期驻场</span></p>
			</div>

			<a-descriptions :column='2'>
				<a-descriptions-item label="驻场ID">
					{{chooseinfo.factory_id}}
				</a-descriptions-item>
				<a-descriptions-item label="驻场人员">

					{{chooseinfo.username}}(ID:{{chooseinfo.id}})
				</a-descriptions-item>
				<a-descriptions-item label="预计结束时间">
					{{chooseinfo.end_date?chooseinfo.end_date:'长期'}}
				</a-descriptions-item>
			</a-descriptions>
			<div>
				是否确认<span class='red'>提前结束</span>外派驻场，确认后，该人员则无需进行驻场打卡，
				<span class='org'>此操作不可逆，请谨慎操作</span>
			</div>
		</a-modal>

	<a-modal title="查看规则" width='30%' :maskClosable='true' :visible="see_visible" @cancel='see_visible=false'
			@ok='see_visible=false'>
			<div>
				<a-descriptions :column='2'>
					<a-descriptions-item label="工厂名称">
						{{see_info.factory_name}}
					</a-descriptions-item>
					<a-descriptions-item label="工厂ID">
						{{see_info.id}}
					</a-descriptions-item>
					<a-descriptions-item label="工厂地址">
						{{see_info.address}}
					</a-descriptions-item>
					<a-descriptions-item label="打卡半径">
						{{see_info.radius}}米
					</a-descriptions-item>

				</a-descriptions>
				
				
				<div v-if='see_info.night_open==1&&see_info.peak_open==0'>
					
					<a-alert class="mt10" message="打卡规则" banner type="info" show-icon>
						<template #icon><a-icon type="caret-right" /></template>
					</a-alert>
					<div class="mt10">
						
						<div >
							<p class="mt10"><span
									class="red">*</span><span>白班上班时间：{{see_info.off_day_start}}~{{see_info.off_day_end}}</span>
							</p>
						</div>
						<div >
							<p class="mt10"><span
									class="red">*</span><span>晚班上班时间：{{see_info.off_night_start}}~{{see_info.off_night_end}}</span>
							</p>
						</div>
						<p class="mt10"><span
								class="red">*</span><span>打卡频率：<span>每{{see_info.peak_frequency}}小时打卡1次</span></span></p>
					</div>
				</div>
				<div v-else>
					<a-alert class="mt10" message="旺季打卡规则" banner type="info" show-icon>
						<template #icon><a-icon type="caret-right" /></template>
					</a-alert>
					<div class="mt10">
						<div v-if='see_info.off_night_start'>
					
							<p class="mt10"><span
									class="red">*</span><span>旺季白班时间：{{see_info.peak_day_sta}}~{{see_info.peak_day_end}}</span>
							</p>
							<p class="mt10"><span
									class="red">*</span><span>旺季晚班时间：{{see_info.peak_night_start}}~{{see_info.peak_night_end}}</span>
							</p>
						</div>
						<div v-else>
							<p class="mt10"><span
									class="red">*</span><span>上班时间：{{see_info.peak_day_start}}~{{see_info.peak_day_end}}</span>
							</p>
						</div>
						<p class="mt10"><span
								class="red">*</span><span>旺季打卡频率：<span>每{{see_info.peak_frequency}}小时打卡1次</span></span></p>
					</div>
					
					<a-alert class="mt10" message="淡季打卡规则" banner type="info" show-icon>
						<template #icon><a-icon type="caret-right" /></template>
					</a-alert>
					<div class="mt10">
						<div v-if='see_info.off_night_start'>
						<p class="mt10"><span
								class="red">*</span><span>淡季白班时间：{{see_info.off_day_start}}~{{see_info.off_day_end}}</span>
						</p>
						<p class="mt10"><span
								class="red">*</span><span>淡季晚班时间：{{see_info.off_night_start}}~{{see_info.off_night_end}}</span>
						</p>
						</div>
						<div v-else>
							<p class="mt10"><span
									class="red">*</span><span>上班时间：{{see_info.off_day_start}}~{{see_info.off_day_end}}</span>
							</p>
						</div>
						<p class="mt10"><span
								class="red">*</span><span>淡季打卡频率：<span>每</span>{{see_info.off_frequency}}<span>小时打卡1次</span></span>
						</p>
					</div>
				</div>
			
				<a-alert class="mt10" message="其他规则" banner type="info" show-icon>
					<template #icon><a-icon type="caret-right" /></template>
				</a-alert>
				<div class="mt10">
					<p class="mt10"><span class="red">*</span><span>容错窗口：前后{{see_info.tolerance}}分钟</span></p>
					<p class="mt10">容错期内打卡视为合规，超出容错期，则不可打卡</p>
				</div>

			</div>
		</a-modal>


	</div>
</template>
<script>
	import {
		user_index
	} from "@/api/user";
	import PopTableList from "@/components/PopTableList";
	import Form from "@/components/Form";
	import TableList from "@/components/TableList";
	import TransferTree from "@/components/TransferTreeTwo";
	import EditPop from "@/components/EditPop";
	import {
		message
	} from 'ant-design-vue';
	import {
		getDayDetail,
		delConfig,
		getUserDetail,
		saveConfig,
		getUserList,
		getUserSelect,
		PersonnelList,
		personnelDetail,
		endPersonnel,
		getRuleDetail,
		getFactoryRule,
		delPersonnel,
		editPersonnel
	} from "@/api/dispatch";
	import {
		post_user
	} from '@/api/api'
	let columns = [{
			title: "驻场ID",
			dataIndex: "id",
		},
		{
			title: "姓名",
			dataIndex: "users",
			scopedSlots: {
				customRender: "users"
			},
		},
		{
			title: "驻场工厂",
			dataIndex: "factory_name",
			scopedSlots: {
				customRender: "factory_name"
			},

		},
		{
			title: "班次",
			dataIndex: "shift_text",
		},
		{
			title: "分管领导",
			dataIndex: "leader_name",
		},
		{
			title: "打卡规则",
			dataIndex: "rule_tag",
			scopedSlots: {
				customRender: "rule_tag",

			},
		},
		{
			title: "驻场日期",
			dataIndex: "rule_item",
			scopedSlots: {
				customRender: "rule_item"
			},
		},

		{
			title: "驻场状态",
			dataIndex: "status",
			scopedSlots: {
				customRender: "status"
			},
		},

		{
			title: "操作",
			scopedSlots: {
				customRender: "operation"
			},
			width: '250px',
			fixed: 'right',
		},
	];

	export default {
		name: "gpoodIndex",
		components: {
			Form,
			TableList,
			TransferTree,
			PopTableList,
			EditPop
		},
		data() {
			return {
				chooseinfo: {},
				see_info: {},
				edit_visible: false,
				end_visible: false,
				see_visible: false,
				del_visible: false,
				delnInfo: {},
				treeData: [],
				rule_user: [],
				treeDataValue: [],
				top_count: [],
				get_table_list: PersonnelList,
				columns,
				treeDataValue: [],
				visible: false,
				form_data: {
					title: '添加',
					list: [{
							type: 'text',
							name: 'id',
							options: {
								initialValue: ''
							},
							hidden: true
						},
						{
							type: "select",
							name: "uids",
							title: "管理者",
							options: {
								initialValue: []
							},
							list: [],
							mode: 'multiple'
						},
						{
							type: 'slot',
							name: 'rule_user',
							title: '添加人员',
							options: {

							},
						},
					]
				},
				form_data_seo: {
					list: [{
							type: 'text',
							name: 'keyword',
							placeholder: '请输入姓名或ID',
							title: '姓名',
						},
						{
							type: "tree-select",
							name: "department_id",
							title: "部门",
							options: {},
							treeData: [],
							multiple: true
						},
						{
							type: 'text',
							name: 'factory_keyword',
							placeholder: '请输入工厂名称或ID',
							title: '工厂',
							options: {
								initialValue: ''
							},
						},

						{
							type: 'select',
							name: 'shift',
							placeholder: '请选择班次',
							title: '班次',
							list: [{
								key: '',
								value: '全部'
							}, {
								key: 1,
								value: '白班'
							}, {
								key: -1,
								value: '晚班'
							}, {
								key: 0,
								value: '常规'
							}, ]
						},
						{
							type: 'select',
							name: 'status',
							placeholder: '请选择状态',
							title: '状态',
							options:{},
							list: [{
								key: '',
								value: '全部'
							}, {
								key: 2,
								value: '待开始'
							}, {
								key: 1,
								value: '进行中'
							}, {
								key: 3,
								value: '已结束'
							}]
						},
						{
							type: 'text',
							name: 'leader_keyword',
							placeholder: '请输入分管领导',
							title: '分管领导',
						},
						{
							type: "range_date",
							name: "range_date",
							title: "时间",
							options: {},
							start: {
								name: 'start_date_start'
							},
							end: {
								name: 'start_date_end'
							},
						},



					],
					...this.$config.form_data_seo
				},
				submit_string: {
					array_to_string: ['uids']
				},
				submit_preprocessing: {
					array_to_string: ['goods_name']
				}
			};
		},
		 created() {
			this.get_User_Select()
			if (this.$route.query.factory_id) {
				this.form_data_seo.list[2].options.initialValue = this.$route.query.factory_id
				this.form_data_seo.list[4].options.initialValue =1
				this.where = this.$route.query
				this.where.status = 1
				
				this.$nextTick(()=>{
					this.$refs.list.get_list();
				})
			}else{
				this.$nextTick(()=>{
					this.$refs.list.get_list();
				})
			}


			post_user().then(res => {
				this.treeData = this.$method.get_user_department_list(res.data.list,
					'sysUserTree')
			})
			this.$method.get_department().then(res => {
				this.form_data_seo.list.forEach(item => {
					if (item.name == "department_id") {
						item.treeData = res;
					}
				});
			});
		},
		methods: {
			disabledDate(current) {
				if (!current) return false
				const tomorrow = new Date()
				tomorrow.setHours(0, 0, 0, 0)
				tomorrow.setDate(tomorrow.getDate() + 1) // 明天 00:00
				return current.valueOf() < tomorrow.getTime()
			},
			editFun(info) {
				this.chooseinfo = info
				this.edit_visible = true
			},


			edit_visible_fun() {
				editPersonnel({data:{"id":this.chooseinfo.id,"uid":this.chooseinfo.uid,"end_date":this.chooseinfo.end_date},info:true}).then(res=>{
					this.edit_visible = false
					this.chooseinfo = {}
					this.$refs.list.get_list();
				})
			},
			del_visibleFun(info) {
				this.delnInfo = info
				this.del_visible = true
			},

			see_rule(data) {
				getFactoryRule({
					data: {
						factory_id: data.factory_id
					}
				}).then(res => {
					this.see_info = res.data
					this.see_visible = true
				})
			},
			setEndTime() {
				endPersonnel({
					data: {
						id: this.chooseinfo.id
					},
					info: true
				}).then(res => {
					this.end_visible = false
					this.chooseinfo = {}
					this.$refs.list.get_list();
				})

			},

			endTime(info) {
				personnelDetail({
					data: {
						id: info.id
					}
				}).then(res => {
					this.chooseinfo = res.data
					this.end_visible = true
				})

			},
			editAdd(record) {
				this.$router.push({
					path: 'useredit',
					query: {
						id: record.id ? record.id : ''
					}

				})
			},
			goReport(record) {
				console.log('res',record)
				this.$router.push({
					path: 'report',
					query: {
						keyword: record.username ? record.username : '',
						factory_keyword: record.factory_name,
						department: record.department_id,
						start_date: record.start_date,
						end_date: record.end_date,
					}

				})
			},
			get_User_Select() {
				getUserSelect().then(res => {
					res.data.list.forEach(item => {
						this.form_data.list[1].list.push({
							value: item.label,
							key: item.value
						})
					})
				})
			},


			TransferTreeChange(value) {
				this.rule_user = value.join(',')
			},
			edit(record) {
				if (record.personnel_id) {
					getUserDetail({
						data: {
							"personnel_id": record.personnel_id,
							"date": record.date

						}
					}).then(res => {
						this.$refs.supervision.$refs.form.setFieldsValue({
							id: record.id
						})

						this.form_data.list.forEach(item => {
							if (item.name == 'rule_user') {
								let treeDataValue = [];
								res.data.list.sub_users.map(io => {
									treeDataValue.push("user_" + io.id)
									io.key = "user_" + io.id;
									io.title = io.username;
									return io;
								});
								this.rule_user = treeDataValue.join(',')
								this.treeDataValue = JSON.parse(JSON.stringify(treeDataValue));

								this.$forceUpdate()
								this.$refs.supervision.refs.form.setFieldsValue({
									[item.name]: treeDataValue.join(',')
								})
							}
							if (item.name == 'uids') {
								let arr = res.data.list.uids.split(',')
								this.$refs.supervision.$refs.form.setFieldsValue({
									[item.name]: arr.map(io => {
										return Number(io)
									})
								})
								this.$forceUpdate()
							}
						})
					})
				}

				this.visible = true
			},
			del(record) {
				delPersonnel({
					data: {
						id: this.delnInfo.id
					},
					info: true,
				}).then(res => {
					this.del_visible = false;
					this.delnInfo = {}
					this.$refs.list.get_list();
				})
			},
			submit(e) {
				let data = e.values;
				if (!data.id) {
					data.id = '';
				}
				saveConfig({
					data: {
						"uids": data.uids ? data.uids.join(',') : '',
						"sub_users": this.rule_user,
						"id": data.id
					},
					info: true,
				}).then(res => {
					this.visible = false;
					this.$refs.list.get_list();
				})
			},

		}
	};
</script>

<style lang="less">
	@import url("../../assets/less/app.less");

	.max_price_tips {
		margin-left: 99px;
		margin-top: -30px;
		font-size: 13px;
	}

	.float_left {
		margin-right: 8px;
	}

	.max_price_form {
		.item {
			display: flex;

			.right {
				flex: 1;

				.input_number {
					width: 100%;
				}
			}
		}
	}

	.page_content_top {
		display: flex;

		div {
			flex: 1;
			text-align: center;
		}

		div:nth-child(3) {
			cursor: pointer;
		}
	}

	.info_item {
		display: flex;
		font-size: 16px;
		line-height: 35px;

		span {
			flex: 1;
			text-align: right;
		}

		span:nth-child(2) {
			flex: 2;
			text-align: left;
			margin-left: 10px;
		}
	}

	.wTime {
		padding: 0 6px;
		width: 100px;
		height: 32px;
		line-height: 32px;
		background: #E9FFE0;
		color: #246F0A;
		text-align: center;
		margin-bottom: 8px;
	}

	.nowTime {
		padding: 0 6px;
		width: 100px;
		height: 32px;
		line-height: 32px;
		background: #FDF6EA;
		color: #B97104;
		text-align: center;
	}

	.status1 {
		width: 80px;
		height: 28px;
		line-height: 28px;
		background: #E9FFE0;
		color: #246F0A;
		text-align: center;
		margin-bottom: 8px;
	}

	.status2 {
		width: 80px;
		height: 28px;
		line-height: 28px;
		background: #E8F1FF;
		color: #397DEE;
		text-align: center;
	}

	.blue {
		color: #397DEE;

	}

	.status3 {

		width: 80px;
		height: 28px;
		line-height: 28px;
		background: #EFF4FF;
		color: #000;
		text-align: center;
	}

	.red {
		color: #F93317;
	}

	.org {
		color: orange;
	}

	.tips {
		height: 40px;
		line-height: 40px;
		background: #FDF6EA;
		padding: 0 12px;
		margin-bottom: 12px;
		font-size: 14px;
	}

	.date-picker-wrapper {
		display: flex;
		flex-direction: column;
		gap: 4px;
		/* 控制日期框和提示文字之间的间距 */
	}

	.tip-text {
		margin: 0;
		font-size: 12px;
		color: #999999;
		/* 灰色文字 */
		line-height: 1.5;
	}
</style>